/**
 * Statuses are a MANAGED dictionary since 2026-10-14 (F-01/F-23): the seven
 * built-ins are seeded `system: true` (renamable, reorderable, never
 * deletable) and custom ones live alongside them. `registry.statuses` ARRAY
 * ORDER is the display order of every filter, select and status sort.
 *
 * These helpers are the single place that turns that array into options,
 * labels and a sort rank — every call site stays one line and no view ever
 * reaches for the closed enum again (the built-in tuples remain only as the
 * DEFAULT labels / fallback order).
 */

import { defaultStatusLabel } from '../api/types';
import type { ProjectStatus, RegistryStatus } from '../api/types';

/** The `<option>` list of a status select/filter: dictionary order, current labels. */
export function statusOptions(statuses: readonly RegistryStatus[]): Array<{ value: string; label: string }> {
  return statuses.map((status) => ({ value: status.id, label: status.label }));
}

/**
 * Label of a status id: the dictionary's (possibly renamed) label first, then
 * the built-in default, then the id itself — an unknown id must still display
 * something readable, never `undefined`.
 *
 * (The status SORT rank lives in `lib/filters.ts` as `statusRankLookup` —
 * sorting belongs with the other comparators there.)
 */
export function statusLabel(statuses: readonly RegistryStatus[], id: ProjectStatus): string {
  return statuses.find((status) => status.id === id)?.label ?? defaultStatusLabel(id);
}
